import { useEffect, useState } from "react";
import { readCookie } from "../lib/bootConfig";
import { APPRADIO_ORIGIN } from "../lib/origins";

export function Header() {
  const [uid, setUid] = useState("");
  const [displayName, setDisplayName] = useState("Conta");

  useEffect(() => {
    setUid(readCookie("RPRO_USER_UID"));
    const name = readCookie("RPRO_DISPLAY_NAME");
    if (name) setDisplayName(name);
  }, []);

  useEffect(() => {
    const toggle = document.getElementById("rpHeaderToggle");
    const collapse = document.getElementById("rpHeaderCollapse");
    if (!toggle || !collapse) return;
    const icon = toggle.querySelector("i");
    function close() {
      collapse!.classList.remove("is-open");
      toggle!.setAttribute("aria-expanded", "false");
      if (icon) icon.className = "fas fa-bars";
    }
    function open() {
      collapse!.classList.add("is-open");
      toggle!.setAttribute("aria-expanded", "true");
      if (icon) icon.className = "fas fa-xmark";
    }
    const onToggle = (e: Event) => {
      e.stopPropagation();
      if (collapse.classList.contains("is-open")) close();
      else open();
    };
    const onDocClick = (e: MouseEvent) => {
      if (!collapse.contains(e.target as Node) && e.target !== toggle) close();
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") close();
    };
    const onResize = () => {
      if (window.innerWidth > 900) close();
    };
    toggle.addEventListener("click", onToggle);
    document.addEventListener("click", onDocClick);
    document.addEventListener("keydown", onKey);
    window.addEventListener("resize", onResize);
    return () => {
      toggle.removeEventListener("click", onToggle);
      document.removeEventListener("click", onDocClick);
      document.removeEventListener("keydown", onKey);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  useEffect(() => {
    if (!uid) return;
    const menu = document.getElementById("rp-user-menu");
    if (!menu) return;
    const trigger = menu.querySelector(".rp-user-trigger") as HTMLElement | null;
    if (!trigger) return;
    const onClick = (e: Event) => {
      e.preventDefault();
      const open = menu.classList.toggle("is-open");
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
    };
    const onDoc = (e: MouseEvent) => {
      if (!menu.contains(e.target as Node)) {
        menu.classList.remove("is-open");
        trigger.setAttribute("aria-expanded", "false");
      }
    };
    trigger.addEventListener("click", onClick);
    document.addEventListener("click", onDoc);
    return () => {
      trigger.removeEventListener("click", onClick);
      document.removeEventListener("click", onDoc);
    };
  }, [uid]);

  return (
    <header className="rp-header">
      <a className="rp-brand" href="/" aria-label="Radios.PRO">
        <img src="/assets/img/header/logo.png" alt="" loading="eager" decoding="async" />
        <span>
          Radios<em>.PRO</em>
        </span>
      </a>

      <button
        type="button"
        className="rp-header-toggle"
        id="rpHeaderToggle"
        aria-label="Abrir menu"
        aria-expanded="false"
        aria-controls="rpHeaderCollapse"
      >
        <i className="fas fa-bars" aria-hidden="true"></i>
      </button>

      <div className="rp-header-collapse" id="rpHeaderCollapse">
        <div className="rp-header-links">
          <a className="rp-header-link rp-brand-shop" href="https://appradio.store/" target="_blank" rel="noopener">
            Loja
          </a>
          <nav className="rp-header-nav" aria-label="Suporte e contato">
            <a className="rp-header-link" href={`${APPRADIO_ORIGIN}/contato`} target="_blank" rel="noopener">
              Contato
            </a>
            <a className="rp-header-link" href={`${APPRADIO_ORIGIN}/suporte`} target="_blank" rel="noopener">
              Suporte
            </a>
            <button type="button" className="rp-header-link rp-header-link--btn js-rp-suggestion-open" id="rpSuggestionOpen">
              Sugestão
            </button>
          </nav>
        </div>

        <div className="rp-auth" id="rp-auth">
          {uid ? (
            <div className="rp-user-menu" id="rp-user-menu">
              <button type="button" className="rp-user-trigger" aria-haspopup="true" aria-expanded="false">
                <span className="rp-user-name">{displayName}</span>
              </button>
              <div className="rp-user-dropdown" role="menu">
                <a href={`${APPRADIO_ORIGIN}/painel`} target="_blank" rel="noopener" role="menuitem">
                  <i className="fas fa-gauge-high" aria-hidden="true"></i> Meu painel
                </a>
                <a href="/sso/logout" role="menuitem" className="rp-user-logout">
                  <i className="fas fa-arrow-right-from-bracket" aria-hidden="true"></i> Sair
                </a>
              </div>
            </div>
          ) : (
            <a className="rp-login-btn" href="/sso/login" rel="noopener" title="Faça login na sua conta Appradio.pro">
              Entrar
            </a>
          )}
        </div>
      </div>
    </header>
  );
}
